import "./AlertaModal.css";
import { useContext, useState } from "react";
import { PortalContext } from "../../../context/Provider";
import { useHistory } from "react-router";
import { wsLimpiarAlertas } from "../../../context/Actions/alertas/alertas";

const AlertaModal = () => {
  const { alertasState, alertasDispatch } = useContext(PortalContext);
  const [view, setView] = useState(true);
  const history = useHistory();
  // Cierra para siempre

  const faltaOs =
    alertasState.alertas.data?.idtipo &&
    Number(alertasState.alertas.data?.idtipo) === 138;

  const aceptar = async () => {
    setView(false);
    if (faltaOs) {
      history.push("/perfil");
      wsLimpiarAlertas()(alertasDispatch);
    } else {
      history.push("proximosTurnos");
    }
  };
  const cancelar = () => {
    localStorage.setItem("alertaActive", false);
    setView(false);
  };

  if (view) {
    return (
      <>
        <div className="sombra-alertaModal"></div>
        <div className="ptur-alertaModal-container">
          <div className="ptur-alertaModal-header bgcG-latex30">
            <h1 className="rb24t">
              {alertasState.alertas.data?.titulo
                ? alertasState.alertas.data?.titulo
                : "Loading ..."}
            </h1>
          </div>
          <div className="ptur-alertaModal-body">
            <span
              className="span-bold123"
              dangerouslySetInnerHTML={{
                __html: `${
                  alertasState.alertas.data?.descripcion
                    ? alertasState.alertas.data?.descripcion
                    : "Loading ..."
                }`,
              }}
            />
          </div>
          <div className="ptur-alertaModal-containerBtn">
            <button className="ptur-alertaModal-btn" onClick={cancelar}>
              Ver luego
            </button>
            <button className="bgc-latex10" onClick={aceptar}>
              {faltaOs ? "Ir a perfil" : "Subir ahora"}
            </button>
          </div>
        </div>
      </>
    );
  } else {
    return "";
  }
};

export default AlertaModal;
